import type { ModelTypes, ModelTypesWithThirdParty } from "@/modules/editor/constant";
import { Wenxin_Words } from "./wenxin/lang";
import { Third_Party_Words } from "./lang";
import { ModelBasicInfo } from "@/types/creator";

export type ThirdParty = "third-party";
export type ThirdPartyModelTypes = "wenxin" | "draft" | "monkey";
export const THIRD_PARTY_MODEL_TYPE: ThirdParty[] = ["third-party"];
export const THIRD_PARTY_MODEL_TYPES: ThirdPartyModelTypes[] = ["wenxin", "monkey", "draft"];

export interface SingleModelInfo extends ModelBasicInfo<string, ThirdPartyModelTypes> {
  type: "single";
}
export interface MultiModelInfo extends ModelBasicInfo<string, ThirdPartyModelTypes | ThirdParty> {
  type: "multi";
  infos: SingleModelInfo[];
}
export type ModelInfo = SingleModelInfo | MultiModelInfo;

export const THIRD_PARTY_MODEL_TYPES_INFO: Record<ThirdPartyModelTypes, SingleModelInfo> = {
  wenxin: {
    type: "single",
    label: Wenxin_Words["wenxin-model"],
    showInfo: Wenxin_Words["wenxin-model-intro"],
    isHot: true,
    value: "wenxin",
  },
  draft: {
    type: "single",
    label: Third_Party_Words["draft"],
    showInfo: Third_Party_Words["draft"],
    isHot: false,
    value: "draft",
  },
  monkey: {
    type: "single",
    label: Third_Party_Words["monkey"],
    showInfo: Third_Party_Words["monkey"],
    isHot: false,
    value: "monkey",
  },
};
export const THIRD_PARTY_MODEL_TYPE_INFO: Record<ThirdParty, MultiModelInfo> = {
  "third-party": {
    type: "multi",
    value: "third-party",
    showInfo: Third_Party_Words["third-party"],
    label: Third_Party_Words["third-party"],
    infos: [
      {
        type: "single",
        label: Wenxin_Words["wenxin-model"],
        showInfo: Wenxin_Words["wenxin-model-intro"],
        isHot: true,
        value: "wenxin",
      },
      // {
      //   type: "single",
      //   label: Third_Party_Words["monkey"],
      //   showInfo: Third_Party_Words["monkey"],
      //   isHot: false,
      //   value: "monkey",
      // },
    ],
  },
};

export const THIRD_PARTY_SORT_KEY: Record<ThirdPartyModelTypes, string> = {
  wenxin: "text",
  draft: "text",
  monkey: "text",
};

export function isThirdParty(
  model: ModelTypes | ModelTypesWithThirdParty,
): model is ThirdPartyModelTypes | ThirdParty {
  return [THIRD_PARTY_MODEL_TYPES, THIRD_PARTY_MODEL_TYPE].flat().includes(model as any);
}
